import consts from './consts';

export default {
  [consts.GET_ROLE_PULLDOWNLIST](state, payload) {
    const { role_list_func, role_list } = payload
    state.role_list_func = role_list_func
    state.role_list = role_list
  },
  [consts.GET_MENU_ORDER](state, payload) {
    state.menuOrderList = payload
  },
  [consts.GET_ENUMBYKEYS](state, payload) {
    state.enumByKeys = payload
  },
  setImVisible(state, payload) {
    state.imVisible = payload
  }
}
